import { ReactNode } from "react";
import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalProps } from "ds/components/ConfirmationModal/types";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type NewContextFooterContinueConfirmationProps = {
  onConfirm: () => void;
  warning?: ReactNode;
  confirmationButtonLabel: ConfirmationModalProps["confirmationButtonLabel"];
};

const NewContextFooterContinueConfirmation = create(function NewContextFooterContinueConfirmation({
  onConfirm,
  warning,
  confirmationButtonLabel,
}: NewContextFooterContinueConfirmationProps) {
  const modal = useModal();

  const handleOnConfirm = () => {
    onConfirm();
    modal.hide();
  };

  return (
    <ConfirmationModal
      onConfirm={handleOnConfirm}
      confirmationButtonVariant="primary"
      confirmationButtonLabel={confirmationButtonLabel}
    >
      <ConfirmationModalMessage>
        {warning || "You have unsubmitted changes"}
      </ConfirmationModalMessage>
    </ConfirmationModal>
  );
});

export const showNewContextFooterContinueConfirmation = (
  props: NewContextFooterContinueConfirmationProps
) => show(NewContextFooterContinueConfirmation, props);
